import React, { useEffect, useRef, useState } from 'react'
import { ADMIN_ICON, LOGO_IMG, PROFILE_IMG } from '../../../../utills/image-constant'
import Inputwithlable from '../../../../admin/components/common/inputwithlable'
import { useDispatch, useSelector } from 'react-redux';
import { addEmployee, getUserById, uploadFile } from '../../../../services/api-services';
import { toastEmitter } from '../../../../utills/utilities';
import { API_RESPONSE } from '../../../../utills/app-constant';
import { setloggedEmployeerReducer } from '../../../../admin/hooks/redux/slice/logged-employee';
import moment from 'moment';
import Loginbtn from '../../../../admin/components/common/loginbtn';
import { useNavigate } from 'react-router-dom';
import { USERROUTES } from '../../../routes/url-constant';
import Leftbar from '../../comman.js/leftbar';

const UserProfile = () => {
    const [userProfile, setUserProfile] = useState();
    const [Employeebtndisable, setEmployeebtndisable] = useState(false);
    const [EmployeebtnLoader, setEmployeebtnLoader] = useState(false);
    const parsedEmployeeData = useSelector((state) => state?.loggedEmployee?.value);
    const navigate = useNavigate();
    const [employeeData, setEmployeeData] = useState({
        id: "",
        employeeName: "",
        email: "",
        mobileNumber: "",
        department: "",
        companyId: "",
        modelId: "",
        modelName: "",
        image: "",
        assessmentFrom: "",
        assessmentTo: "",
        hierarchy: "",
        type: "",

    });

    const imgRef = useRef();
    const dispatch = useDispatch();
    const handleImgClick = (e) => {
        imgRef.current.click();
    };

    const OnFileUpload = (e) => {
        let file = e?.target?.files?.[0];
        setUserProfile(URL?.createObjectURL(file));
        if (file?.size > 5242880) {
            toastEmitter(
                "error",
                "Failed to upload an image. The image maximum size is 5MB."
            );
            return false;
        }
        if (
            file?.type === "image/png" ||
            file?.type === "image/jpeg" ||
            file?.type === "image/jpg"
        ) {
            uploadProfile(file);
        } else {
            return toastEmitter(
                "error",
                "The type of the uploaded image should be in png, jpeg, jpg format."
            );
        }
    };

    const uploadProfile = async (file) => {
        const formdata = new FormData();
        formdata.append("file", file);
        try {
            const response = await uploadFile(formdata);
            if (response?.data?.responseCode == 200) {
                setUserProfile(response?.data?.responseBody)
                setEmployeeData({
                    ...employeeData, image: response?.data?.responseBody
                })
                toastEmitter("success", response?.data?.message);
            } else {
                // setButtonStatus(false)
                toastEmitter("error", response?.data?.message);
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
        }
    }


    const getUserDetails = async () => {
        try {
            const response = await getUserById(parsedEmployeeData?.id);
            if (response?.data?.responseCode == 200) {
                let value = response?.data?.responseBody

                setEmployeeData({
                    ...employeeData,
                    id: value?.id,
                    employeeName: value?.employeeName,
                    mobileNumber: value?.mobileNumber,
                    email: value?.email,
                    department: value?.department,
                    hierarchy: value?.hierarchy,
                    companyId: value?.companyId,
                    modelId: value?.modelId,
                    image: value?.image,
                    modelName: value?.modelName,
                    assessmentFrom: moment(value?.assessmentFrom).format("YYYY-MM-DD"),
                    assessmentTo: moment(value?.assessmentTo).format("YYYY-MM-DD"),
                    type: value?.type
                })
                dispatch(setloggedEmployeerReducer(response?.data?.responseBody));
            } else {
                // setButtonStatus(false)
                toastEmitter("error", response?.data?.message);
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
        }
    }

    useEffect(() => {
        getUserDetails();
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target
        setEmployeeData({ ...employeeData, [name]: value })
    }

    const handleChangeProfile = async () => {
        setEmployeebtndisable(true)
        setEmployeebtnLoader(true)
        try {
            const response = await addEmployee(employeeData);
            if (response?.data?.responseCode !== 200) {
                toastEmitter("error", response?.data?.message);
                setEmployeebtndisable(false)
                setEmployeebtnLoader(false)
            }
            if (response.data?.responseCode === 200) {
                toastEmitter("success", response?.data?.message);
                getUserDetails(parsedEmployeeData?.id)
                setEmployeebtndisable(false)
                setEmployeebtnLoader(false)
                navigate(USERROUTES?.USERPROFILEINTRODUCTION)
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
            setEmployeebtndisable(false)
            setEmployeebtnLoader(false)
        }
    }

    return (
        <>
            <div className="user_profile_intro">
                <div className="user_data">
                    <div className='row'>
                        <div className='col-4'>
                            <Leftbar pageName="UserTestIntro" />
                        </div>
                        <div className='col-8'>
                            <div className='p-3'>
                                <div className='logo-sec'>
                                    <img src={LOGO_IMG} className="responsive-img mt-3 mb-3 logo_img" alt="Logo" />
                                </div>
                                <div className="admin_profile p-3">
                                    <div className="d-flex justify-content-center align-items-center position-relative">
                                        <div className="profile-img-div">
                                            <img
                                                src={employeeData?.image ? employeeData?.image : userProfile ? userProfile : PROFILE_IMG}
                                                className="profileimg  mb-3"
                                                alt="PROFILE_IMG"
                                            />
                                        </div>
                                        <div className="">
                                            <img
                                                src={ADMIN_ICON}
                                                className="mb-3 profile-icon"
                                                type="button"
                                                alt="WHITEBGDOWNARROW_IMG"
                                                onClick={handleImgClick}
                                            />
                                            <input
                                                className="form-control"
                                                type="file"
                                                hidden
                                                ref={imgRef}
                                                id="imgFileUpload"
                                                accept="image/*"
                                                onChange={OnFileUpload}
                                            />
                                        </div>

                                    </div>
                                    <div className="row ">
                                        <div className="col-md-6">
                                            <Inputwithlable
                                                placeHolder="Enter Name"
                                                name="employeeName"
                                                type="text"
                                                labelName="Name"
                                                lableclassName="addInput-label"
                                                className="form-control addInputText-lable"
                                                value={employeeData.employeeName}
                                                handleChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Inputwithlable
                                                placeHolder="Enter Email"
                                                name="email"
                                                type="text"
                                                labelName="Email"
                                                lableclassName="addInput-label"
                                                className="form-control addInputText-lable"
                                                value={employeeData.email}
                                                disable={true}
                                                handleChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-center align-items-center'>

                                        <Loginbtn
                                            className="submitbtn px-5 mt-5 mb-5"
                                            handleClick={handleChangeProfile}
                                            type="submit"
                                            btnName="Save Changes"
                                            disablebtn={Employeebtndisable}
                                            loader={EmployeebtnLoader}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </>

    )
}

export default UserProfile;
